// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__Bnw7g","span":"SuperEditableSpan_span__+BAJg","input":"SuperEditableSpan_input__y++2w","pen":"SuperEditableSpan_pen__0l4Gx"};